<template>
  <div class="upload-wrapper">
    <el-upload
      class="image-uploader"
      action="http://your-server-ip:3000/api/upload"
      :headers="headers"
      :multiple="true"
      :limit="limit"
      :file-list="fileList"
      list-type="picture-card"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      accept=".jpg,.jpeg,.png">
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip">
        支持 jpg/png 格式，单个文件不超过 5MB，最多上传 {{ limit }} 张
      </div>
    </el-upload>

    <!-- 已上传文件列表 -->
    <div v-if="uploadedFiles.length > 0" class="uploaded-list">
      <h4>上传成功的文件：</h4>
      <el-table :data="uploadedFiles" size="small" border>
        <el-table-column prop="originalname" label="原始文件名" min-width="150"></el-table-column>
        <el-table-column prop="size" label="大小" width="100">
          <template slot-scope="scope">
            {{ formatFileSize(scope.row.size) }}
          </template>
        </el-table-column>
        <el-table-column label="图片预览" width="100">
          <template slot-scope="scope">
            <!-- 新上传完成的行带一次轻微回弹，作为「成功了」的即时反馈；
                 首次渲染的旧数据不加动画，避免进页面时整表乱弹 -->
            <el-image
              :class="{ 'bounce-feedback': scope.row.__justUploaded }"
              style="width: 50px; height: 50px"
              :src="scope.row.url"
              :preview-src-list="[scope.row.url]"
              fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="copyUrl(scope.row.url)">复制链接</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUpload',
  data() {
    return {
      fileList: [],
      uploadedFiles: [],
      limit: 10,
      headers: {}
    }
  },
  methods: {
    // 上传前校验
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isJPG && !isPNG) {
        this.$toast.error('只支持 jpg/png 格式的图片!')
        return false
      }
      if (!isLt5M) {
        this.$toast.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },

    // 上传成功
    handleSuccess(response, file, fileList) {
      if (response.success) {
        this.$toast.success(`${file.name} 上传成功!`)
        // 标记为「刚上传」，让缩略图播一次回弹；动画结束后清掉标记，
        // 否则后续列表重排（v-for key 复用）会让它反复播放。
        const record = { ...response.data, __justUploaded: true }
        this.uploadedFiles.push(record)
        this.$emit('upload-success', response.data)

        const idx = this.uploadedFiles.length - 1
        setTimeout(() => {
          if (this.uploadedFiles[idx] === record) {
            this.$set(record, '__justUploaded', false)
          }
        }, 400)
      } else {
        this.$toast.error(response.message || '上传失败')
      }
    },

    // 上传失败
    handleError(err, file) {
      this.$toast.error(`${file.name} 上传失败: ${err.message}`)
      this.$emit('upload-error', err)
    },

    // 移除文件
    handleRemove(file, fileList) {
      const index = this.uploadedFiles.findIndex(item => item.url === file.url)
      if (index > -1) {
        this.uploadedFiles.splice(index, 1)
      }
      this.$emit('remove', file)
    },

    // 超出限制
    handleExceed() {
      this.$toast.warning(`最多只能上传 ${this.limit} 张图片!`)
    },

    // 格式化文件大小
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB'
      } else {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
      }
    },

    // 复制链接
    copyUrl(url) {
      navigator.clipboard.writeText(url).then(() => {
        this.$toast.success('链接已复制到剪贴板')
      }).catch(() => {
        this.$toast.error('复制失败')
      })
    },

    // 清空列表
    clearList() {
      this.fileList = []
      this.uploadedFiles = []
    }
  }
}
</script>

<style scoped>
.upload-wrapper {
  padding: 20px;
}

.image-uploader {
  margin-bottom: 20px;
}

.uploaded-list {
  margin-top: 20px;
  padding: 15px;
  background-color: var(--surface-2);
  border-radius: 4px;
}

.uploaded-list h4 {
  margin-bottom: 10px;
  color: #303133;
}

.el-upload__tip {
  color: #606266;
  margin-top: 10px;
}
</style>
